import {
    requestInterceptor,
    requestRejectedInterceptor,
    responseInterceptor,
    responseRejectedInterceptor,
} from "./interceptors";
import { jdIpRequestInterceptor } from "./jdIpInterceptor";
import mainServerClient from "./mainServerClient";
import PddDeviceFingerPrintInterceptor from "./PddDeviceFingerPrint/PddDeviceFingerPrintInterceptor";
import { jushitaAxios, pddAxios, jdAxios, aliyunAxios, doudianAxios } from "./platformAxios";

mainServerClient.http.interceptors.request.use(requestInterceptor, requestRejectedInterceptor);
mainServerClient.http.interceptors.response.use(responseInterceptor, responseRejectedInterceptor);

// 注册拦截器
jushitaAxios.interceptors.request.use(requestInterceptor, requestRejectedInterceptor);
jushitaAxios.interceptors.response.use(responseInterceptor, responseRejectedInterceptor);

pddAxios.interceptors.request.use(requestInterceptor, requestRejectedInterceptor);
pddAxios.interceptors.request.use(PddDeviceFingerPrintInterceptor);
pddAxios.interceptors.response.use(responseInterceptor, responseRejectedInterceptor);

jdAxios.interceptors.request.use(requestInterceptor, requestRejectedInterceptor);
jdAxios.interceptors.request.use(jdIpRequestInterceptor);
jdAxios.interceptors.response.use(responseInterceptor, responseRejectedInterceptor);

aliyunAxios.interceptors.request.use(requestInterceptor, requestRejectedInterceptor);
aliyunAxios.interceptors.response.use(responseInterceptor, responseRejectedInterceptor);

doudianAxios.interceptors.request.use(requestInterceptor, requestRejectedInterceptor);
doudianAxios.interceptors.response.use(responseInterceptor, responseRejectedInterceptor);
